import { PulseLoader } from "react-spinners";

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner">
      <PulseLoader color="#eba267" size={10} />
    </div>
  );
};

export default LoadingSpinner; 